<template>
  <app-board :header="false" class="p-3">
    <moduleForm :dataContainer="dataContainer" :edit-mode="false" :formHeader="true" :formTitle="'add ' + module.info.caption"></moduleForm>
  </app-board>
</template>

<script>
    import dataContainer from 'devegram-vue-data-collecter-eui/src/mixins/dataContainer';
    import module from './../index.js'

    export default {
        mixins: [dataContainer],
        components: {
            moduleForm: () => import('./../form/View'),

        },
        data() {
            return {
                dataContainer: this,
                module: module
            }
        }
    }
</script>
